import React from 'react';
import Divider from "@mui/material/Divider";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle
} from "@mui/material";
import "./Modal.css";

export default function Modal({
  headerIcon,
  isOpen,
  onClose,
  header,
  size,
  children,
  className,
  PaperProps,
  hasHeader = true,
}) {



  const MyIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 30 30" fill="none">
      <path d="M15.9082 3.63281C15.9082 2.9856 15.3835 2.46094 14.7363 2.46094C14.0891 2.46094 13.5645 2.9856 13.5645 3.63281C13.5645 4.28002 14.0891 4.80469 14.7363 4.80469C15.3835 4.80469 15.9082 4.28002 15.9082 3.63281ZM17.3145 3.63281C17.3145 5.05667 16.1602 6.21094 14.7363 6.21094C13.3125 6.21094 12.1582 5.05667 12.1582 3.63281C12.1582 2.20895 13.3125 1.05469 14.7363 1.05469C16.1602 1.05469 17.3145 2.20895 17.3145 3.63281Z" fill="black" />
      <path d="M16.4941 7.61719C16.4941 7.2374 16.3872 6.99581 16.2577 6.82938C16.1205 6.65295 15.9235 6.51786 15.6898 6.41773C15.4563 6.31763 15.213 6.26417 15.0214 6.2368C14.9275 6.22338 14.8504 6.21694 14.7992 6.2138C14.7736 6.21224 14.7548 6.21148 14.7439 6.21117C14.7407 6.21107 14.7381 6.21097 14.7363 6.21094C14.7345 6.21097 14.732 6.21107 14.7288 6.21117C14.7179 6.21148 14.699 6.21224 14.6735 6.2138C14.6222 6.21694 14.5452 6.22338 14.4513 6.2368C14.2597 6.26417 14.0164 6.31763 13.7828 6.41773C13.5492 6.51786 13.3522 6.65295 13.215 6.82938C13.0855 6.99581 12.9785 7.2374 12.9785 7.61719V8.37891H16.4941V7.61719ZM17.9004 9.78516H11.5723V7.61719C11.5723 6.9423 11.7729 6.39286 12.1049 5.96603C12.4291 5.54921 12.8473 5.28878 13.2289 5.12524C13.6106 4.96167 13.9825 4.88329 14.2524 4.84474C14.3891 4.82521 14.5043 4.81517 14.5877 4.81007C14.6294 4.80751 14.6635 4.80621 14.6886 4.80549C14.7012 4.80513 14.7115 4.80491 14.7195 4.8048C14.7235 4.80475 14.727 4.80471 14.7298 4.80469H14.7358C14.7361 4.80515 14.7363 4.82225 14.7363 5.45059C14.7363 4.82225 14.7366 4.80515 14.7369 4.80469H14.7429C14.7457 4.80471 14.7492 4.80475 14.7532 4.8048C14.7611 4.80491 14.7715 4.80513 14.784 4.80549C14.8092 4.80621 14.8432 4.80751 14.885 4.81007C14.9683 4.81517 15.0836 4.82521 15.2203 4.84474C15.4901 4.88329 15.8621 4.96167 16.2437 5.12524C16.6253 5.28878 17.0436 5.54921 17.3678 5.96603C17.6998 6.39286 17.9004 6.9423 17.9004 7.61719V9.78516Z" fill="black" />
      <path d="M22.3828 8.4375H7.38281C6.86505 8.4375 6.44531 8.831 6.44531 9.31641V10.4883C6.44531 10.9737 6.86505 11.3672 7.38281 11.3672H22.3828C22.9006 11.3672 23.3203 10.9737 23.3203 10.4883V9.31641C23.3203 8.831 22.9006 8.4375 22.3828 8.4375Z" fill="black" />
      <path d="M21.9501 9.375H7.8155C7.64126 9.375 7.5 9.50617 7.5 9.66797V10.2539C7.5 10.4157 7.64126 10.5469 7.8155 10.5469H21.9501C22.1244 10.5469 22.2656 10.4157 22.2656 10.2539V9.66797C22.2656 9.50617 22.1244 9.375 21.9501 9.375Z" fill="white" />
      <path d="M23.1325 10.7227L21.8164 23.5547H8.12515L6.80908 10.7227H23.1325ZM9.39453 22.1484H11.338V20.3906H13.9161V22.1484H16.0255V20.3906H18.6036V22.1484H20.547L21.5747 12.1289H8.36685L9.39453 22.1484Z" fill="black" />
      <path d="M22.9395 22.5586H5.6543V23.7305H22.9395V22.5586Z" fill="black" />
      <path d="M16.7578 16.9922C16.7578 16.0214 15.9708 15.2344 15 15.2344C14.0292 15.2344 13.2422 16.0214 13.2422 16.9922C13.2422 17.963 14.0292 18.75 15 18.75C15.9708 18.75 16.7578 17.963 16.7578 16.9922ZM18.1641 16.9922C18.1641 18.7397 16.7475 20.1562 15 20.1562C13.2525 20.1562 11.8359 18.7397 11.8359 16.9922C11.8359 15.2447 13.2525 13.8281 15 13.8281C16.7475 13.8281 18.1641 15.2447 18.1641 16.9922Z" fill="black" />
      <path d="M10.4297 4.6875C10.4297 4.55806 10.3248 4.45312 10.1953 4.45312C10.0659 4.45312 9.96094 4.55806 9.96094 4.6875C9.96094 4.81694 10.0659 4.92188 10.1953 4.92188C10.3248 4.92188 10.4297 4.81694 10.4297 4.6875ZM11.6016 4.6875C11.6016 5.46415 10.972 6.09375 10.1953 6.09375C9.41866 6.09375 8.78906 5.46415 8.78906 4.6875C8.78906 3.91085 9.41866 3.28125 10.1953 3.28125C10.972 3.28125 11.6016 3.91085 11.6016 4.6875Z" fill="black" />
      <path d="M13.8281 11.7188H11.4844V13.7109H13.8281V11.7188Z" fill="black" />
      <path d="M18.6328 11.7188H16.2891V13.7109H18.6328V11.7188Z" fill="black" />
      <path d="M9.78928 5.9223L8.67188 7.0397V8.49631H7.5V6.55436L8.96072 5.09375L9.78928 5.9223Z" fill="black" />
    </svg>
  );

  return (
    <Dialog
      open={isOpen}
      onClose={onClose}
      maxWidth="md"

      PaperProps={{
        component: "form",
        className: `${className} ${size}`,
        ...PaperProps // Spread the PaperProps
      }}


    >
      {hasHeader &&
        <DialogTitle sx={{ padding: "0.1875rem 1.125rem", fontSize: "1rem" }}>
          <div className="title-dialog">

            <h2>
              {headerIcon && (
                headerIcon === "create_conference" ? (
                  <MyIcon />
                ) : (
                  <span className="material-symbols-outlined">
                    {headerIcon}
                  </span>
                )
              )}
              {header}
            </h2>

            <span className="material-symbols-outlined cursor-pointer" onClick={onClose}>
              close
            </span>
          </div>

          <Divider
            sx={{
              marginTop: "0.125rem",
              marginBottom: "0.8125rem",
              backgroundColor: "#CDD5DF"
            }}
          />
        </DialogTitle>
      }
      {!hasHeader &&
        <span className="material-symbols-outlined cursor-pointer without-header" onClick={onClose}>
          close
        </span>
      }

      {children}
    </Dialog>
  );
}
